export function openDB(dbName = 'napa-web', storeName) {
    return new Promise((resolve, reject) => {
    const request = window.indexedDB.open(dbName, 2);

    request.onupgradeneeded = event => {
      const db = event.target.result;
      db.createObjectStore(storeName, { keyPath: 'id' });
    };

    request.onsuccess = event => {
      resolve(event.target.result);
    };

    request.onerror = event => {
      reject(event.target.error);
    };
  });
}

export const saveRecord = async (db, storeName, data) => {
  const transaction = db.transaction([storeName], 'readwrite');
  const store = transaction.objectStore(storeName);

  const request = store.add(data);

  request.onerror = event => {
    console.error('Error saving data:', event.target.error);
  };
};

export function fetchRecords(db, storeName) {
  return new Promise((resolve, reject) => {
    const transaction = db.transaction(storeName, 'readonly');
    const objectStore = transaction.objectStore(storeName);
    const request = objectStore.getAll();

    request.onerror = (event) => {
      reject(`Error fetching records: ${event.target.error}`);
    };

    request.onsuccess = (event) => {
      const records = event.target.result;
      resolve(records);
    };
  });
}

export const updateRecord = async (db, storeName, key, newData) => {
  const transaction = db.transaction([storeName], 'readwrite');
  const store = transaction.objectStore(storeName);

  const getRequest = store.get(key);

  getRequest.onsuccess = () => {
    const existingData = getRequest.result;
    const updatedData = { ...existingData, ...newData };
    const updateRequest = store.put(updatedData);

    updateRequest.onerror = (event) => {
      console.error('Error updating record:', event.target.error);
    };
  };

  getRequest.onerror = (event) => {
    console.error('Error retrieving record:', event.target.error);
  };
};

export function deleteRecords(db, storeName, records) {
  return new Promise((resolve, reject) => {
    const transaction = db.transaction(storeName, 'readwrite');
    const objectStore = transaction.objectStore(storeName);

    records.forEach((record) => {
      const request = objectStore.delete(record.id);

      request.onerror = (event) => {
        reject(`Error deleting record with id ${record.id}: ${event.target.error}`);
      };
    });

    transaction.oncomplete = () => {
      resolve();
    };

    transaction.onerror = (event) => {
      reject(`Error deleting records: ${event.target.error}`);
    };
  });
}